export const ensureCorrectCommissionFormat = value => value?.replace(',', '.') ?? null

export const buildCommonInsuranceContractParameters = ({
  type,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action = 'save',
}) => {
  const options = new URLSearchParams()

  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('action', action)

  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('product_type', characteristicsData.productType || '')

  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')
  options.append('provider_external_id', contractData.providerExternalId || '')
  options.append('whatsapp_consent', contactPreferences?.whatsappConsent ? '1' : '0')

  if (contractData.annualPremium?.length > 0) {
    options.append('annual_premium', ensureCorrectCommissionFormat(contractData.annualPremium))
  }
  if (contractData.annualCommission?.length > 0) {
    options.append('annual_commission', ensureCorrectCommissionFormat(contractData.annualCommission))
  }
  if (contractData.businessCard !== undefined) {
    options.append('business_card', contractData.businessCard === 1 ? '1' : '0')
  }
  if (contactPreferences?.createReviewsInteraction) {
    options.append('create_reviews_interaction', '1')
  }

  return options
}
